import { FC, ReactNode } from 'react';
import { Tr } from '@utils';
import { Button, ButtonProps, Stack, StackProps, Typography } from '@mui/material';

export interface IFormStepLayoutProps extends Omit<StackProps, 'title'> {
	title?: ReactNode;
	hidePrimaryButton?: boolean;
	hideSecondaryButton?: boolean;
	primaryButtonProps?: Extendable<ButtonProps>;
	secondaryButtonProps?: Extendable<ButtonProps>;
}

export const FormStepLayout: FC<IFormStepLayoutProps> = ({
	title,
	hidePrimaryButton,
	hideSecondaryButton,
	primaryButtonProps = {},
	secondaryButtonProps = {},
	children,
	sx,
	...props
}) => {
	const { children: primaryChildren } = primaryButtonProps;
	const { children: secondaryChildren } = secondaryButtonProps;
	const hasButtons = !hideSecondaryButton || !hidePrimaryButton;
	return (
		<Stack
			direction="column"
			spacing={5}
			sx={{ marginTop: 5, marginBottom: hasButtons ? -1 : 0, flexGrow: 1, maxHeight: 1.0, overflowY: 'auto', ...sx }}
			{...props}
		>
			<Stack direction="column" sx={{ paddingX: 9, flexGrow: 1, overflowY: 'auto' }}>
				{title ? (
					<Typography variant="h4" sx={{ marginBottom: 4 }}>
						{title}
					</Typography>
				) : null}
				{children}
			</Stack>
			{hasButtons ? (
				<Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ marginBottom: '8px !important' }}>
					{!hideSecondaryButton ? (
						<Button variant="outlined" color="secondary" data-testid="form-step-back-button" {...secondaryButtonProps}>
							{secondaryChildren || <Tr.Portal path="back" />}
						</Button>
					) : null}
					{!hidePrimaryButton ? (
						<Button variant="contained" data-testid="form-step-next-button" {...primaryButtonProps}>
							{primaryChildren || <Tr.Portal path="next" />}
						</Button>
					) : null}
				</Stack>
			) : null}
		</Stack>
	);
};
